var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"timer-header"},[_vm._v("\n  "+_vm._s(_vm.hours)+" : "+_vm._s(_vm.minutes)+" : "+_vm._s(_vm.seconds)+" Hrs\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }